import Moment from "moment";

export const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue,
    );
    return result;
  }, {});
};

export function isEmpty(obj) {
  // null and undefined are "empty"
  if (obj == null) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

export function searchObjects(arrayOfObjects, excludeColumns, searchKey) {
  return arrayOfObjects.filter((item) => {
    return Object.keys(item).some((key) =>
      excludeColumns.includes(key)
        ? false
        : item[key]
            .toString()
            .toLowerCase()
            .includes(searchKey.toLowerCase().trim()),
    );
  });
}

export function setLocalStorage(storageName, data) {
  localStorage.setItem(storageName, data);
}

export function getLocalStorage(storageName) {
  localStorage.setItem(storageName);
}

export function removeLocalStorage(storageName) {
  localStorage.removeItem(storageName);
}

export function formatDate(date) {
  return Moment(date).format("YYYY-MM-DD HH:mm:ss");
}
